<template>
  <div>

    <base-header class="pb-6 bg-light">

      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">HSS Records</h6> &nbsp;
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="6">
          <div class="input-group">
            <b-input-group>
              <template #prepend>
                <b-input-group-text :style="ps">ICCID</b-input-group-text>
              </template>
              <b-form-input id="iccid" type="text" v-model="iccid" @change="getProfileData"></b-form-input>
              <template #append>
                <base-button size="lg" type="light" title="Search" v-on:click="getProfileData">
                  <i class="fa fa-search"></i>
                </base-button>
              </template>
            </b-input-group>
          </div>
          <br>
        </b-col>
        <b-col xl="6"></b-col>
      </b-row>

      <b-row v-if="!hasData">
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <div v-if="submitLoading" class="text-center">
                <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
              </div>
              <div  v-if="!submitLoading"  class="text-center">
                Please enter a valid iccid that exists in the system.
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="hasData">
        <b-col xl="6">
          <b-card no-body>
            <b-card-body>
              <table class="table b-table">
                <tr>
                  <th colspan="2" :style="ps">
                    <div>SIM Information</div>
                  </th>
                </tr>
              </table>
              <div class="table-responsive">
                <b-table
                  :items="profile_data_src.simInfo"
                  head-row-variant="light"
                >
                </b-table>
              </div>
            </b-card-body>
          </b-card>
        </b-col>

        <b-col xl="6">
          <b-card no-body>
            <b-card-body>
              <table class="table b-table">
                <tr>
                  <th colspan="2" :style="ps">
                    <div>IMS Information</div>
                  </th>
                </tr>
              </table>
              <div class="table-responsive">
                <b-table id="log_table"
                         :items="profile_data_src.imsInfo"
                         head-row-variant="light"
                >
                </b-table>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="hasData">
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <table class="table b-table">
                <tr>
                  <th colspan="2" :style="ps">
                    <div>Subscriber Info</div>
                  </th>
                </tr>
              </table>
              <div class="table-responsive">
                <b-table id="log_table"
                         :items="profile_data_src.subscriberInfo"
                         head-row-variant="light"
                >
                </b-table>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

    </base-header>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import hssDashboardService from "@/common/api-services/hss-dashboard-service";
import ToastVue from '../../Components/Toast.vue';
export default {
  components: {
    RouteBreadCrumb,
    ToastVue
  },

  data() {
    return {
      ps: 'background-color:rgba(94,114,228);color:#FFFFFF;width:150px',
      submitLoading: false,
      hasData: false,
      iccid: '',
      profile_data_src: [],
    }
  },

  mounted() {
    document.title = 'HSS - Profile';
    this.loadPageData();
  },

  methods: {

    async loadPageData() {
      try {
        this.iccid = this.$route.query.iccid;
        if (!this.iccid || this.iccid.length !== 20) {
          throw new Error('Invalid ICCID.');
        } else {
          this.getProfileData();
        }
      } catch (e) {
        //this.showToasterMsg('[loadPage]Error:' + e.message, true, 'error');
      }
    },

    async getProfileData() {
      this.submitLoading = true;
      await hssDashboardService.query(this.iccid, 'advanced').then(res => {
        if (res.data.message) {
          this.profile_data_src = res.data.message;
          this.hasData = true;
        } else {
          this.hasData = false;
          this.profile_data_src = [];
        }
        //this.submitLoading = false;
      }).catch(e=>{
        this.hasData = false;
        console.log(e);
      }).finally(x=>{
        this.submitLoading = false;
      });
    },


    formatStatus(str) {
      str = `${str}`;
      str = str.toLowerCase();
      if (str === 'true') {
        str = 'Activated';
      } else if (str === 'false') {
        str = 'Not Activated';
        // } else if (String(str)) {
        //   str = str.replace('{','').replace('}','');
        // } else {
        //str = txt;
      }
      return str;
    },
    // isJsonString(str) {
    //   try {
    //     JSON.parse(str);
    //   } catch (e) {
    //     console.error(str);
    //     console.error(e);
    //     return false;
    //   }
    //   return true;
    // },
    refreshPage() {
      setTimeout(() => {
        //another way to refresh table data...
        //this.$root.$emit('bv::refresh::table', 'my-table');
        //this.$refs.table.refresh()
        this.profile_data_src = null;
        this.loadPageData();
      }, 1000);
    },

    showToasterMsg(message, append = false, variant = 'success') {
      //setup for alert
      this.$toast({
        component: ToastVue,
        props: {
          description: message
        }
      }, {
        type: variant
      })
    },
  },
}

</script>

